import { Vue, Component } from 'vue-property-decorator'
import GrossingTouchSidepanelWrapper from '@/modules/grossingModule/grossing-touch-view/components/grossing-touch-sidepanel-wrapper/grossing-touch-sidepanel-wrapper.vue'
import PriorityDot from '@/modules/clinicalModule/components/StatusRequestPriorityDot.vue'

@Component({
    components: {
        GrossingTouchSidepanelWrapper,
        PriorityDot
    }
})

export default class GrossingTouchProtocolsSidepanel extends Vue {
    private grossingProtocols !: Array<object>
    private protocolSelectionBarActive !: Boolean
    private prioritySelected !: string

    constructor() {
        super()
        this.protocolSelectionBarActive = false
        this.prioritySelected = 'normal-priority'
        this.grossingProtocols = [
            {
                prtName: 'Amiloidosis',
                prtId: 11,
                protocolAssays: [
                    {
                        assay: {
                            name: 'Hematoxilina Eosina'
                        }
                    }
                ]
            },
            {
                prtName: 'Centinela Piel',
                prtId: 12,
                protocolAssays: [
                    {
                        assay: {
                            name: 'Hematoxilina Eosina'
                        }
                    },
                    {
                        assay: {
                            name: 'Corte sin teñir'
                        }
                    },
                    {
                        assay: {
                            name: 'Melan A'
                        }
                    }
                ]
            },
            {
                prtName: 'Cilindro Hígado',
                prtId: 13,
                protocolAssays: [
                    {
                        assay: {
                            name: 'PAS'
                        }
                    },
                    {
                        assay: {
                            name: 'Tricrómico de Masson'
                        }
                    },
                    {
                        assay: {
                            name: 'Tinción de Jones'
                        }
                    },
                    {
                        assay: {
                            name: 'Corte sin teñir'
                        }
                    }
                ]
            },
            {
                prtName: 'Cilindro Próstata',
                prtId: 14,
                protocolAssays: [
                    {
                        assay: {
                            name: 'Hematoxilina Eosina'
                        }
                    },
                    {
                        assay: {
                            name: 'Azul Alcián'
                        }
                    }
                ]
            }
        ]
    }
}
